<template>
  <section class="page-user-list-content mt-5">
    <!-- TODO add Loading -->
    <!-- <app-loading :isFull="true" v-if="isLoading" /> -->
    <div class="container">
      <div class="row">
        <div class="col-12">
          <list-course-collapse :isShow="true"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import listCourseCollapse from 'cp/min-component/list-course-collapse.vue'
export default {
  name: 'page-user-list-content',
  components: {
    listCourseCollapse
  },
  computed: {
    courseId() {
      return this.$route.params.id
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="less">
@import (reference) "../../../../../../../assets/css/variable.less";
.page-user-list-content {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses/list-content/index.vue